import { notification } from "../antdApp/staticAntd";
import { isString } from "lodash";

// const defaultOptions = {
//     text: null,
//     position: null,
//     duration: null,
// };

// const mergeOptions = (options) => {
//     let baseOptions = {
//         ...defaultOptions,
//     };
//     if (_.isPlainObject(options)) {
//         return {
//             ...baseOptions,
//             ...options
//         };
//     } else if (_.isString(options)) {
//         return {
//             ...baseOptions,
//             text: options
//         };
//     } else {
//         return baseOptions;
//     }
// };

/**
 * a common components for show some alert message
 *  for now we just use the Toast in Native-base
 *  you can pass Toast options or just pass string
 * @type {{show: ((null?: *)), success: ((null?: *)), warning: ((null?: *)), danger: ((null?: *))}}
 */
const MessageBox = {
    show: (options) => {
        try {
            const settings = {};
            if (options.duration) {
                settings.autoClose = options.duration;
                settings.placement = "topRight";
            }
            notification.info({ ...settings, message: isString(options) ? options : options.text });
        } catch (e) {
            // ignore
        }
    },
    success: (options) => {
        try {
            const settings = {};
            if (options.duration) {
                settings.autoClose = options.duration;
                settings.placement = "topRight";
            }
            notification.success({ ...settings, message: isString(options) ? options : options.text });
        } catch (e) {
            // ignore
        }
    },
    warning: (options) => {
        try {
            const settings = {};
            if (options.duration) {
                settings.autoClose = options.duration;
                settings.placement = "topRight";
            }
            notification.warning({ ...settings, message: isString(options) ? options : options.text });
        } catch (e) {
            // ignore
        }
    },
    danger: (options) => {
        try {
            const settings = {};
            if (options.duration) {
                settings.autoClose = options.duration;
                settings.placement = "topRight";
            }
            notification.error({ ...settings, message: isString(options) ? options : options.text });
        } catch (e) {
            // ignore
        }
    },
};

export default MessageBox;
